import { wrapReducer } from "@client/content/lib/helper";
import { type ReduxAction } from "@client/types/ReduxAction";
import { Actions, type InitSuccessActionData } from "./actions";
import { type MemberAffiliateDashboard } from "./types";

const reducer = (
  state: MemberAffiliateDashboard.AppState = defaultState,
  action: ReduxAction<any>
): MemberAffiliateDashboard.AppState => {
  switch (action.type) {
    case Actions.InitBegin: {
      return {
        ...state,
        status: "Loading"
      };
    }
    case Actions.InitFailure: {
      return {
        ...state,
        status: "Failed"
      };
    }
    case Actions.InitSuccess: {
      const { dashboard } = action.data as InitSuccessActionData;

      return {
        ...state,
        ...dashboard,
        status: "Ready"
      };
    }
    // case Actions.LoadLeaderboardSuccess: {
    //   const data = action.data as LoadLeaderboardSuccessActionData;
    //   return {
    //     ...state,
    //     leaderBoard: { ...data, items: [...(state.leaderBoard?.items ?? []), ...data.items] },
    //     status: "Ready"
    //   };
    // }

    default: {
      return state;
    }
  }
};

export const defaultState: MemberAffiliateDashboard.AppState = {
  affiliateDate: null,
  affiliateLinks: [],
  cycleOptions: [],
  error: null,
  id: "",
  incentives: [],
  offers: [],
  status: "None"
};
export const previewState: MemberAffiliateDashboard.AppState = {
  ...defaultState,
  status: "Ready"
};
export default wrapReducer({ defaultState, reducer, previewState });
